import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ServerAction } from '../server.action';

export const endServerProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ServerAction.create.failed,
    ServerAction.remove.done,
    ServerAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      ServerAction.processing.done({}),
    ];
  }),
);
